import Lottie from 'lottie-react';
import { memo } from 'react';

import AgentLoaderLoopDark from '~/components/v2/components/workspace/workspace-agent-panel/animations/AgentLoaderLoopDark.json';
import AgentLoaderLoopLight from '~/components/v2/components/workspace/workspace-agent-panel/animations/AgentLoaderLoopLight.json';
import { useWorkspaceAgentPanelTheme } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/useWorkspaceAgentPanelTheme';

export type WorkspaceAgentPanelToolGroupLoaderProps = {
  animate?: boolean;
  className?: string;
  'data-testid'?: string;
  text?: string;
};

export const WorkspaceAgentPanelToolGroupLoader = memo(
  ({ animate = true, className, 'data-testid': testId, text }: WorkspaceAgentPanelToolGroupLoaderProps) => {
    const theme = useWorkspaceAgentPanelTheme();
    const animationData = theme === 'dark' ? AgentLoaderLoopDark : AgentLoaderLoopLight;

    if (!animate) {
      if (!text) {
        return null;
      }

      return (
        <span
          className="block truncate font-mono font-semibold ads:text-metadata text-10 text-gray-10 leading-5"
          data-testid={testId ?? 'WORKSPACE_AGENT_TOOL_CALL_GROUP_LOADER_TEXT'}
        >
          {text}
        </span>
      );
    }

    if (!text) {
      return (
        <Lottie animationData={animationData} aria-hidden className={className} data-testid={testId} key={theme} loop />
      );
    }

    return (
      <div className="flex w-full min-w-0 max-w-full items-center gap-2 overflow-hidden">
        <Lottie animationData={animationData} aria-hidden className={className} data-testid={testId} key={theme} loop />
        <span
          className="min-w-0 flex-1 truncate font-mono ads:text-metadata text-12 text-gray-10 leading-4"
          data-testid="WORKSPACE_AGENT_TOOL_CALL_GROUP_LOADER_TEXT"
          title={text}
        >
          {text}
        </span>
      </div>
    );
  },
);

WorkspaceAgentPanelToolGroupLoader.displayName = 'WorkspaceAgentPanelToolGroupLoader';
